export function numberSafeParse(input: string): number | null {
  if (input.trim() === '') return null;
  const parsed = Number(input);
  if (!Number.isFinite(parsed)) return null;
  return parsed;
}
